import { Card} from "antd";

export const EventContainer = ({children}) => {

  return (
    <div className="events-app">
      <Card variant="borderless" className="create-event-card">
          {children}
      </Card>
    </div>
  );
};
